import { useCallback, useEffect, useRef } from 'react';

function isJson(data: string) {
  try {
    JSON.parse(data);
  } catch (e) {
    return false;
  }
  return true;
}

/**@deprecated legacy format parse data  */
const deprecatedParseData = (messageEvent: MessageEvent) => {
  const [eventName, payload] = messageEvent.data.split('|');
  if (isJson(payload)) return { eventName, payload: JSON.parse(payload) };
  return { eventName, payload };
};

/**@deprecated check if is a legacy data format  */
const isDeprecatedFormatData = (messageEvent: MessageEvent) => {
  return !isJson(messageEvent.data);
};

function isValidEventData(messageEvent: MessageEvent) {
  return typeof messageEvent.data === 'string';
}

const useExternalEvents = (events: { [key: string]: Function }) => {
  const eventMap = useRef(events);

  const dispatchEvent = useCallback(
    (eventName: string, data?: unknown) => {
      const isAValidEvent = (eventName: string) => {
        return Boolean(eventMap.current[eventName]);
      };

      if (isAValidEvent(eventName)) {
        eventMap.current[eventName](data);
      }
    },
    [eventMap],
  );

  useEffect(() => {
    const messageEventHandler = (messageEvent: MessageEvent) => {
      if (!isValidEventData(messageEvent)) return;
      /**@deprecated remove this conditional when it no longer supports the old format */
      if (isDeprecatedFormatData(messageEvent)) {
        const { eventName, payload } = deprecatedParseData(messageEvent);
        dispatchEvent(eventName, payload);
        return;
      }
      const { event: eventName, payload } = JSON.parse(messageEvent.data);
      dispatchEvent(eventName, payload);
    };

    window.addEventListener('message', messageEventHandler, false);
    return () => {
      window.removeEventListener('message', messageEventHandler, false);
    };
  }, [dispatchEvent, eventMap]);
};

export default useExternalEvents;
